type OrderNumberSource = {
  id: string;
  orderNumber?: number;
};

export function formatOrderNumber(order: OrderNumberSource): string {
  if (typeof order.orderNumber === 'number' && order.orderNumber > 0) {
    return `#${order.orderNumber}`;
  }

  return `#${order.id.slice(0, 8).toUpperCase()}`;
}

export function formatOrderNumberLabel(order: OrderNumberSource): string {
  return `Sipariş ${formatOrderNumber(order)}`;
}
